// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"cd19898b","166":"cd62aeaa","194":"29ea017d","338":"56c74c7d","741":"9da92878","950":"82ea04f2"}[chunkId] + ".chunk.js";
};